import { Injectable } from '@angular/core';

import { TxnFilter, TxnDataSource } from '../txns/txn.service';

@Injectable()
export class FilterService {
  dataSource: TxnDataSource;

  update(filter: TxnFilter): void {
    this.dataSource.filter = filter;
  }
}



// WEBPACK FOOTER //
// /srv/src/app/search/filter.service.ts